import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1691.24894,1016.47059 C1663.69129,1376.18824 1376.14306,1663.62353 1016.42541,1691.29412 L1016.42541,1468.23529 L903.484235,1468.23529 L903.484235,1691.29412 C543.766588,1663.62353 256.331294,1376.18824 228.773647,1016.47059 L451.719529,1016.47059 L451.719529,903.529412 L228.773647,903.529412 C256.331294,543.811765 543.766588,256.376471 903.484235,228.705882 L903.484235,451.764706 L1016.42541,451.764706 L1016.42541,228.705882 C1376.14306,256.376471 1663.69129,543.811765 1691.24894,903.529412 L1468.19012,903.529412 L1468.19012,1016.47059 L1691.24894,1016.47059 Z M1804.19012,903.529412 C1776.18071,481.581176 1438.48659,143.774118 1016.42541,115.764706 L1016.42541,0 L903.484235,0 L903.484235,115.764706 C481.536,143.774118 143.841882,481.581176 115.832471,903.529412 L-0.0451764706,903.529412 L-0.0451764706,1016.47059 L115.832471,1016.47059 C143.841882,1438.41882 481.536,1776.22588 903.484235,1804.23529 L903.484235,1920 L1016.42541,1920 L1016.42541,1804.23529 C1438.48659,1776.22588 1776.18071,1438.41882 1804.19012,1016.47059 L1919.95482,1016.47059 L1919.95482,903.529412 L1804.19012,903.529412 Z M960,1242.35294 C804.367059,1242.35294 677.647059,1115.63294 677.647059,960 C677.647059,804.367059 804.367059,677.647059 960,677.647059 C1115.63294,677.647059 1242.35294,804.367059 1242.35294,960 C1242.35294,1115.63294 1115.63294,1242.35294 960,1242.35294 M960,564.705882 C742.023529,564.705882 564.705882,742.023529 564.705882,960 C564.705882,1177.97647 742.023529,1355.29412 960,1355.29412 C1177.97647,1355.29412 1355.29412,1177.97647 1355.29412,960 C1355.29412,742.023529 1177.97647,564.705882 960,564.705882",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTargetLine = /*#__PURE__*/function (_Component) {
  _inherits(IconTargetLine, _Component);

  var _super = _createSuper(IconTargetLine);

  function IconTargetLine() {
    _classCallCheck(this, IconTargetLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconTargetLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTarget",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTargetLine.displayName = "IconTargetLine";
  return IconTargetLine;
}(Component);

IconTargetLine.glyphName = 'target';
IconTargetLine.variant = 'Line';
IconTargetLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTargetLine;
export { IconTargetLine };